// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2-hg1";
export var footerInner = "footer-module--footerInner--1KZ01";
export var buttons = "footer-module--buttons--edJD0";
export var rights = "footer-module--rights--2vEEF";